const Hypher = require('hypher');
const english = require('hyphenation.en-us');

const MIN_WORD_LENGTH = 10;
const SKIPPED_TAGS = new Set([
    'code',
    'kbd',
    'pre',
    'samp',
    'script',
    'style',
    'textarea',
]);

const englishHyphenator = new Hypher(english);

function addSoftHyphens(value, minLength = MIN_WORD_LENGTH) {
    if (typeof value !== 'string' || !value) return value;
    return englishHyphenator.hyphenateText(value, minLength);
}

function candidateNode(word) {
    return {
        type: 'element',
        tagName: 'span',
        properties: { dataEmergencyHyphenWord: 'true' },
        children: [{ type: 'text', value: word }],
    };
}

function splitHyphenationCandidates(value) {
    const parts = value.split(/([A-Za-zÀ-ÖØ-öø-ÿ]{10,})/g);
    if (parts.length === 1) return null;

    return parts
        .filter(Boolean)
        .map((part) =>
            /^[A-Za-zÀ-ÖØ-öø-ÿ]+$/.test(part) &&
            englishHyphenator.hyphenate(part).length > 1
                ? candidateNode(part)
                : { type: 'text', value: part }
        );
}

function wrapHyphenationCandidates(node, skip = false) {
    if (!node || typeof node !== 'object') return;

    const tagName =
        node.type === 'element' && typeof node.tagName === 'string'
            ? node.tagName.toLowerCase()
            : '';
    const shouldSkip =
        skip ||
        SKIPPED_TAGS.has(tagName) ||
        node.properties?.dataNoHyphenation != null;

    if (!Array.isArray(node.children)) return;

    node.children = node.children.flatMap((child) => {
        if (child.type === 'text' && !shouldSkip) {
            return splitHyphenationCandidates(child.value) || child;
        }
        wrapHyphenationCandidates(child, shouldSkip);
        return child;
    });
}

function rehypeEmergencyHyphenation() {
    return (tree) => wrapHyphenationCandidates(tree);
}

module.exports = { addSoftHyphens, rehypeEmergencyHyphenation };
